import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AutotextService } from 'src/app/autotext.service';
import { ExamsService } from 'src/app/exams.service';
import { GastroFormsService } from 'src/app/gastro-forms.service';
import { GastroService } from 'src/app/gastro.service';
import { LoginService } from 'src/app/login.service';
import { MedicationService } from 'src/app/medication.service';
import { SignatureService } from 'src/app/signature.service';
import { PatientsService } from 'src/app/patients.service';

@Component({
    selector: 'app-preparation',
    templateUrl: './preparation.component.html',
    styleUrls: ['./preparation.component.scss'],
    standalone: false
})
export class PreparationComponent implements OnInit, OnDestroy {
  showTimeOutForm = false;
  sub = new Subscription();
  filteredOptions:any[] = [];
  // filteredOptions: Observable<string[]>;
  // filteredOptionsPrep:any[] = [];
  filteredOptionsPrep: Observable<string[]>;
  item;
  inputControl: UntypedFormControl = new UntypedFormControl()
  options: any[] = ["Olympus"];
  optionsPrep: any[] = ['Fast','Picosalax + laxadin', 'Meroken', 'Moviprep', 'Fleet enema', 'laxadin']
  itemId;
  // timeoutSTR=`לפני התחלת הפעולה מולא טופס פסק זמן-נעשה ווידוי שם המטופל/ת וסוג הבדיקה שאמור הנבדק/ת לעבור\nהבדיקה בוצעה לאחר מתן הסבר על מהלך הבדיקה וסיבוכיה, ולאחר שנתקבלה הסכמה מלאה של הנבדק/ת.\nבמהלך הבדיקה המטופל קיבל חמצן, בוצע ניטור רציף של הדופק וריווי החמצן בדם כמוכן ניטור של הנשימה ולחץ דם.`
  // imageSTR = 'Olympus';
  constructor(
    public ls: LoginService,
    public gs: GastroService,
    public es: ExamsService,
    public atS: AutotextService,
    public medS: MedicationService,
    public gfs: GastroFormsService,
    public signatureService: SignatureService,
    private patService: PatientsService,
  ) {}

  // AR-24 change 3: AI medical-history summary from the patient's answered questionnaire.
  aiSummaryLoading = false;
  getAiSummary() {
    if (this.aiSummaryLoading) return;
    this.aiSummaryLoading = true;
    this.es.getAiSummary(this.es.ExamType, this.patService.getPat()?.PID).subscribe(
      (res: any) => {
        this.aiSummaryLoading = false;
        if (res && res.summary) {
          const control = this.gs.gastroForm?.get('Reasone');
          if (control) {
            const existing = (control.value || '').toString().trim();
            const previous = (res.previousSummary || '').toString().trim();
            // Replace only our own previously-pasted AI block (exact match), so a
            // doctor's hand-typed notes are never overwritten; otherwise append.
            if (previous && existing === previous) {
              control.setValue(res.summary);
            } else {
              control.setValue(existing ? existing + '\n\n' + res.summary : res.summary);
            }
          }
        } else if (res && res.reason) {
          alert('Could not generate a summary (' + res.reason + ').');
        }
      },
      () => {
        this.aiSummaryLoading = false;
      }
    );
  }

  ngOnInit() {
    this.sub = this.es.formLoaded$.subscribe(() => {
      const examObject = this.es.examObject;
      const isExamSigned = this.signatureService.isExamSigned(examObject);

      if (!this.es.isClosed && !isExamSigned) {
        if(! this.medS.Medication.get('Unit').value)
          this.medS.Medication.get('Unit').setValue('mg', {emitEvent:false});

          // if(! this.gs.gastroForm.get('imag1').value)
          //   this.gs.gastroForm.get('imag1').patchValue(this.imageSTR, {emitEvent:false});
          // if(! this.gs.gastroForm.get('scope1').value)
          //   this.gs.gastroForm.get('scope1').patchValue(this.imageSTR, {emitEvent:false});
        this.getText(93);
        this.getText(94);
        this.getText(95);
        this.filteredOptionsPrep = this.gs.gastroForm.get('inputControl').valueChanges.pipe(startWith(''),
          map(value => this._filter(value)),
        );
      }
    })
  }
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.optionsPrep.filter(option => option.toLowerCase().includes(filterValue));
  }

  getClass(text:any){
    if(this.gs.gastroForm.get('Medication').value)
      return 'type-v'
    return 'type-plus'
  }
  addAndSave(option:any, formcontrol:any, id:any, inPrep = false){
    if(inPrep){
      this.optionsPrep.push(option);
    }else{
      this.options.push(option);
    }
    if(this.gs.gastroForm.get(formcontrol).value !== ""){
      this.atS.showAuto(this.gs.gastroForm.get(formcontrol), formcontrol, id,false)
      var res = this.atS.saveText(option, null)
      this.sub = res.subscribe((data)=>{
        if(this.itemId == null)
          this.itemId = data['insertId'];
      },(error)=>{
        console.log(error);
      });
    }
  }

  Save(option){
    var temp = this.gs.gastroForm.get('Preparetion').value
    if(temp){
      temp = temp + ' \n ' + option
    }else{
      temp = option
    }
    this.gs.gastroForm.get('Preparetion').setValue(temp);
    this.gs.gastroForm.get('inputControl').setValue('');
  }
  getText(field){
    var res = this.atS.getTexts(field);
      this.sub = res.subscribe((data:any) => {
        data.forEach((d) => {
          if(d.DlgID == 95){
            this.optionsPrep.push(String(d.Text))
          }else{
            this.options.push(String(d.Text))
          }
        })
        this.inputControl.patchValue('');
      })
  }
  close(){
      this.showTimeOutForm = false;
    if(this.ls.userType==='nurse' || this.ls.userType==='doctor' && !this.es.isClosed)
    this.timeOutFormToString()
  }

  // checkIn(){
  //   this.filteredOptions = this.options.filter(option => option.includes(this.inputControl.value));
  //   return this.options.filter(option => option.includes(this.inputControl.value)).length > 0;
  // }
  // checkInPrep(){
  //   return this.optionsPrep.filter(option => option.includes(this.gs.gastroForm.get('inputControl').value)).length > 0;
  // }
  checkInPrep() {
    const inputValue = this.gs.gastroForm.get("inputControl").value;
    if (this.optionsPrep && inputValue !== null) {
      return (
        this.optionsPrep.filter((option) => option.includes(inputValue))
          .length > 0
      );
    }
    return false;
  }


timeOutFormToString(){
  let timeOutString = ""

  function addComma() {
    if (timeOutString) {
      timeOutString += ', ';
    }
  }
  if (this.gfs.Form.get('IdentetyMatchBreclate').value == 1) {
    timeOutString += ' השם ומספר ת.ז תואמים לפרטי הנבדק/ת '
    addComma()
  }
  if (this.gfs.Form.get('IdentetyMatchBreclate').value == 0) {
    timeOutString += ' השם ומספר ת.ז לא תואמים לפרטי הנבדק/ת '
    addComma()
  }
  if (this.gfs.Form.get('Identety').value == 1) {
    timeOutString += ' הנבדק/ת חזר/ה בקול על ת.ז, שם ושם משפחה '
    addComma()
  }
  if (this.gfs.Form.get('Identety').value == 0) {
    timeOutString += ' הנבדק/ת לא  חזר/ה בקול על ת.ז, שם ושם משפחה '
    addComma()
  } 
  if (this.gfs.Form.get('Guardian').value == 1) {
    timeOutString += ` הזיהוי בוצע ע"י אפוטרופוס ${this.gfs.Form.get('GuardianName').value} ${this.gfs.Form.get('GuardianID').value} `;
    addComma()
  }
  if (this.gfs.Form.get('IdentetyMatchDocumante').value == 1) {
    timeOutString += ' השם ומספר ת.ז תואמים למסמכים '
    addComma()
  }
  if (this.gfs.Form.get('IdentetyMatchDocumante').value == 0) {
    timeOutString += ' השם ומספר ת.ז לא תואמים למסמכים '
    addComma()
  }
  if (this.gfs.Form.get('Prosthesis').value == 1) {
    timeOutString += ' שיניים תותבות '
    addComma()
  }
  if (this.gfs.Form.get('Prosthesis').value == 0) {
    timeOutString += ' ללא שיניים תותבות '
    addComma()
  }
  if (this.gfs.Form.get('DAC').value == 1) {
    timeOutString += ` תרופות נגד קרישיות דם ${this.gfs.Form.get('DACComments').value ? `פרטים: ${this.gfs.Form.get('DACComments').value}` : ''}`;
    addComma()
  }
  
  if (this.gfs.Form.get('DAC').value == 0) {
    timeOutString += ' ללא תרופות נגד קרישיות דם '
    addComma()
  }
  if (this.gfs.Form.get('validconcentFormSedation').value == 'valid') {
    timeOutString += ' טפסי הסכמה לסדציה: תקין'
    addComma()
  }
  if (this.gfs.Form.get('validconcentFormSedation').value == 'notvalid') {
    timeOutString += ' טפסי הסכמה לסדציה: לא תקין'
    addComma()
  }
  if (this.gfs.Form.get('validconcentFormAction').value == 'valid') {
    timeOutString += ' טפסי הסכמה לפעולה: תקין'
    addComma()
  }
  if (this.gfs.Form.get('validconcentFormAction').value == 'notvalid') {
    timeOutString += ' טפסי הסכמה לפעולה: לא תקין'
    addComma()
  }
  if (this.gfs.Form.get('Equipment').value == 1) {
    timeOutString += ` זמינות ותקינות הציוד בחדר: תקין ${this.gfs.Form.get('EquipmentNote').value ? `פירוט: ${this.gfs.Form.get('EquipmentNote').value}` : ''}` 
    addComma()
  }
  if (this.gfs.Form.get('Equipment').value == 0) {
    timeOutString += ` זמינות ותקינות הציוד בחדר: לא תקין ${this.gfs.Form.get('EquipmentNote').value ? `פירוט: ${this.gfs.Form.get('EquipmentNote').value}` : ''}`;
    addComma()
  }
  if(this.gfs.Form.get('MedicationType').value){
    timeOutString += ` סוג הרדמה : ${ this.gfs.Form.get('MedicationType').value}`;
    addComma()

  }
  if(this.gfs.Form.get('medSens').value){
    timeOutString+= ' רגישות לחומרים :'  +`${this.gfs.Form.get('medSens').value}`
    }
  if(timeOutString){
    this.gs.gastroForm.get('TimeOut').patchValue(timeOutString);
  }
}
  ngOnDestroy(): void {
    if(this.sub){
      this.sub.unsubscribe();
    }
  }

}
